export const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/capabilities", label: "Capabilities" },
  { href: "/services", label: "Services" },
  { href: "/portfolio", label: "Portfolio" },
  { href: "/blog", label: "Blog" },
  { href: "/careers", label: "Careers" },
  { href: "/contact", label: "Contact" },
];

export const FOOTER_LINKS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/capabilities", label: "Capabilities" },
  { href: "/services", label: "Services" },
  { href: "/portfolio", label: "Portfolio" },
  { href: "/blog", label: "Blog" },
  { href: "/careers", label: "Careers" },
  { href: "/contact", label: "Contact" },
];

export const STATS = [
  { value: "250+", label: "Projects Delivered", unit: "PROJECTS" },
  { value: "400k+", label: "Lives Impacted", unit: "LIVES" },
  { value: "10+", label: "Years of Experience", unit: "YEARS" },
  { value: "100%", label: "Customer Satisfaction", unit: "SATISFACTION" },
];

export const INDUSTRIES = [
  {
    number: "01",
    name: "Retail",
    description: "Streamlined operations and elevated customer experiences for modern retail businesses.",
  },
  {
    number: "02",
    name: "E-Commerce",
    description: "Scalable storefronts and platforms built for growth across global markets.",
  },
  {
    number: "03",
    name: "Fintech",
    description: "Secure, compliant financial applications enabling digital payments and smart analytics.",
  },
  {
    number: "04",
    name: "Healthcare",
    description: "Secure, compliant, and user-centric healthcare applications that improve patient outcomes.",
  },
  {
    number: "05",
    name: "Education",
    description: "Interactive platforms and personalized content delivery for modern learners.",
  },
];

export type TeamMember = {
  name: string;
  role: string;
  bio: string;
  avatar: string;
  skills?: string[];
};

export const CHAPTERS = [
  {
    id: "web-dev",
    number: "01",
    title: "Web Development",
    description:
      "Scattered UI blocks fly together into a live, production-grade web application — nav, hero, dashboards, and content assembling before your eyes.",
  },
  {
    id: "mobile-app",
    number: "02",
    title: "Mobile App Development",
    description:
      "Loose screens and components snap into a polished native app for iOS and Android — feeds, profiles, and flows becoming one product.",
  },
  {
    id: "ai-chatbot",
    number: "03",
    title: "AI Chatbots",
    description:
      "Messages, avatars, and intents converge into a real conversational assistant that understands, answers, and takes action.",
  },
  {
    id: "ai-agents",
    number: "04",
    title: "AI Agents",
    description:
      "Autonomous agents assemble from tools, memory, and goals — reasoning, calling APIs, and completing multi-step work on their own.",
  },
  {
    id: "workflows",
    number: "05",
    title: "Automation Workflows",
    description:
      "Triggers, actions, and logic nodes wire themselves into an end-to-end automation — an n8n-style pipeline coming to life.",
  },
  {
    id: "blockchain",
    number: "06",
    title: "Blockchain & Fintech",
    description:
      "Blocks, transactions, and smart contracts link into a secure, verifiable chain powering the next generation of finance.",
  },
];
